import { useEffect } from "react";

// Title, description, canonical and JSON-LD for the careers pages. Google
// renders JavaScript, so these count for search; chat apps don't, which is
// what the per-page link previews are for (see lib/share.js).

const MARK = "data-careers-meta";

const setTag = (selector, create, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    el.setAttribute(MARK, "");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

const metaTag = (attr, key, content) =>
  setTag(`meta[${attr}="${key}"]`, () => {
    const el = document.createElement("meta");
    el.setAttribute(attr, key);
    return el;
  }, { content });

export default function useDocumentMeta({ title, description, canonical, jsonLd }) {
  useEffect(() => {
    if (!title) return undefined;
    const previousTitle = document.title;
    document.title = title;

    if (description) {
      metaTag("name", "description", description);
      metaTag("property", "og:description", description);
    }
    metaTag("property", "og:title", title);
    if (canonical) {
      setTag('link[rel="canonical"]', () => document.createElement("link"), {
        rel: "canonical",
        href: canonical,
      });
    }

    let script = null;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute(MARK, "");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      document.title = previousTitle;
      document.head.querySelectorAll(`[${MARK}]`).forEach((el) => el.remove());
    };
  }, [title, description, canonical, jsonLd]);
}
